import ImportExportIcon from '@mui/icons-material/ImportExport';
import { formatTranslation } from 'intl';
import { useAppNavigation } from 'contexts/navigation';
import { useProjectId } from 'store/project';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { ActionButton } from './actionButton';
import { signalNavigationOutsideDocumentation } from 'store/documentation/hooks/useDocumentationUrlNavigation';
import { DocumentationTranslationKeys } from 'intl/keys';

interface GoToSourceIssueButtonProps {
  isMobile: boolean;
}

export const GoToSourceIssueButton: React.FC<GoToSourceIssueButtonProps> = ({
  isMobile,
}) => {
  const intl = useIntl();
  const projectId = useProjectId();
  const location = useLocation();
  const [file] = useGalleryContext<{
    sourceIssueId?: string;
  }>().useMainDisplayedFile(identitySelector);
  const { goToIssueDetails } = useAppNavigation();

  const sourceIssueId = file?.sourceIssueId;
  const hasSourceIssue = Boolean(projectId && sourceIssueId);

  const label = formatTranslation(intl, DocumentationTranslationKeys.goToSourceIssueAction,);
  const unavailableLabel = formatTranslation(intl, DocumentationTranslationKeys.sourceIssueMissingTooltip,);

  const handleGoTo = useCallback((): void => {
    if (!projectId || !sourceIssueId) return;
    const returnUrl = `${location.pathname}${location.search}`;
    // Signal that we're navigating outside documentation to prevent redirect back
    signalNavigationOutsideDocumentation();
    goToIssueDetails(projectId, sourceIssueId, {
      state: { returnUrl },
    });
  }, [
    location.pathname,
    location.search,
    projectId,
    sourceIssueId,
    goToIssueDetails,
  ]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleGoTo}
      disabled={!hasSourceIssue}
      tooltipTitle={hasSourceIssue ? label : unavailableLabel}
      label={label}
      icon={<ImportExportIcon fontSize='small' />}
    />
  );
};
